import React from 'react';

import { prepareOptionsForLocationSearch } from "../../src/js/helpers";
import TopMenu from "../SharedComponents/TopMenu";
import Footer from "../SharedComponents/Footer";
import LocationSection from "./LocationSection";
import Members from "./Members";

import './index.sass';


const ContactsPage = ({ categories, footer, regions, topMenu }) => {

  const regionsOptions = prepareOptionsForLocationSearch(regions);

  return (
    <div className="contacts">
      <TopMenu
        {...topMenu}
        categories={categories}
        regionsOptions={regionsOptions}
        withSearch={true}
      />

      <div className="contacts__wrapper container">
        <h1>Om os</h1>

        <div className="contacts__about-us">
          <div className="contacts__about-us-title">
            Selskabslokaler.dk er en portal, der annoncerer ledige fest- og selskabslokaler i Danmark.
          </div>
          <div className="contacts__about-us-content">
            <p>Gratis og enkelt tilbyder vi at markedsføre dit selskabslokale til vores 40.000 månedlige besøgende. Alle lokaler der kan benyttes til festlige arrangementer, byder vi velkommen på siden, hvad enten der er tale om en kro, bar, et konferencelokale eller noget helt fjerde.</p>
            <p>Selskabslokaler.dk formidler halvdelen af selskabslokaler i Danmark, og vores ambition er at formidle størstedelen af alle lokaler i Danmark, der kan benyttes til festlige arrangementer.</p>
            <p>Vi ønsker at give vores besøgende de bedste forudsætninger for en vellykket fest, og vi giver derfor gode råd til festplanlægningen. Vi arbejder desuden hen imod at kunne henvise til relevante samarbejdspartnere, så alt til festplanlægningen samles her.</p>
            <p>Selskabslokaler.dk er en søstervirksomhed til <a href="http://www.lokalebasen.dk" target="_blank">Lokalebasen.dk</a>, der formidler erhvervslejemål. Vi er et engageret team med base på Nørrebro, og vi har været i gang siden 2008.</p>
          </div>
        </div>

        <LocationSection { ...footer } />

        <Members />

      </div>

      <Footer { ...footer } />
    </div>
  )
}

export default ContactsPage;
